import { useState } from 'react';
import './App.css';
import background from './Wurst.png'; // ✅ Bild importieren

const baseRatios = [
  { name: 'Salz', amountPer1000g: 21 },
  { name: 'Zucker', amountPer1000g: 4 },
  { name: 'Pfeffer', amountPer1000g: 1 },
  { name: 'Senfsaat', amountPer1000g: 1},
  { name: 'Vitamin C', amountPer1000g: 4},
  { name: 'Knoblauchpulver', amountPer1000g: 1 },
];

function App() {
  const [meatAmount, setMeatAmount] = useState(1000);

  const handleChange = (e) => {
    setMeatAmount(Number(e.target.value));
  };

  const calculatedSpices = baseRatios.map((spice) => {
    const amount = (meatAmount / 1000) * spice.amountPer1000g;
    return { ...spice, amount: amount.toFixed(2) };
  });

  return (
    <div
      style={{
        backgroundImage: `url(${background})`, // ✅ Bild verwenden
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        minHeight: '100vh',
        color: 'white',
        padding: '2rem',
        textAlign: 'center',
        fontFamily: 'Arial',
      }}
    >
      <h1>Gewürzrechner</h1>
     <div style={{ margin: '2rem 0', fontSize: '1.5rem' }}>
  <label style={{ marginRight: '1rem' }}>
    Fleischmenge (g): 
  </label>
  <input 
    type="number" 
    value={meatAmount} 
    onChange={handleChange} 
    style={{
      padding: '0.5rem 1rem',
      fontSize: '1.2rem',
      borderRadius: '0.5rem',
      border: '1px solid #ccc',
      width: '150px',
    }}
  />
</div>


      <h2>Benötigte Gewürze:</h2>
      <ul style={{ listStyle: 'none', padding: 0, maxWidth: '300px', margin: '0 auto' }}>
  {calculatedSpices.map((spice) => (
    <li
      key={spice.name}
      style={{
        display: 'flex',
        justifyContent: 'space-between',
        padding: '0.3rem 0',
        borderBottom: '1px solid rgba(255, 255, 255, 0.2)',
      }}
    >
      <span style={{ textAlign: 'left' }}>{spice.name}</span>
      <span style={{ textAlign: 'right' }}>{spice.amount} g</span>
    </li>
  ))}
</ul>

    </div>
  );
}

export default App;
